import Paper from '@material-ui/core/Paper'

import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => ({
	root: {
		width: "100%",
		marginBottom: theme.spacing.unit,
		padding: theme.spacing.unit,
	}
}))(Paper)
